import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';

import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import LinkViewModelType from '@/ViewModels/Controls/LinkViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';

export default class UserCircleLinkViewModel extends ControlViewModel {
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');
    private LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelType>('LinkViewModel');

    public link: LinkViewModel;

    public constructor(params: any) {
        super(params);

        this.link = this.createLinkViewModel(this.handlerOrDefault(params.onClick));
    }

    private createLinkViewModel(onClick: Function): LinkViewModelType {
        const user = RADApplication.getInstance().user;
        return new this.LinkViewModel({
            label: new this.LabelViewModel({
                caption: this.defineComputed(() => {
                    const firstName = user.firstName();
                    const lastName = user.lastName();
                    return this.getInitial(firstName) + this.getInitial(lastName);
                })
            }),
            tooltip: new this.LabelViewModel({
                caption: user.objectIdentValue
            }),
            onClick: onClick
        })
    }

    private getInitial(value: string): string {
        if (!value)
            return '';
        return value.charAt(0).toUpperCase();
    }
}

ComponentManager.setViewModel('UserCircleLinkViewModel', UserCircleLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');